import { isStatus } from '@/utils'
import { PROJECT_STATUSES } from '../constants'
import type { Project, ProjectStatusKey } from '../stores'

export const hasProjectStarted = (project: Project | null) =>
  !isProjectStatus(project, 'notStarted') || project?.firstProcessedAt

export const isProjectProcessing = (project: Project | null) =>
  isProjectStatus(project, 'processing')

export const hasProjectSucceeded = (project: Project | null) =>
  isProjectStatus(project, 'succeeded')

export const hasProjectFailed = (project: Project | null) =>
  isProjectStatus(project, 'failed')

export const hasProjectFinished = (project: Project | null) =>
  isProjectStatus(project, 'failed', 'succeeded')

export const isProjectAssembling = (project: Project | null) =>
  isProjectStatus(project, 'combining', 'duplicating')

export const hasAssemblyFailed = (project: Project | null) =>
  isProjectStatus(project, 'combineFailed', 'duplicateFailed')

// Anything the server is still working on, whether it is assembling the project
// or extracting from it. Use it to gate actions, not to describe what is running.
export const isProjectBusy = (project: Project | null) =>
  isProjectProcessing(project) || isProjectAssembling(project)

export const isProjectStatus = (
  project: Project | null,
  ...expectations: ProjectStatusKey[]
) => isStatus(PROJECT_STATUSES, project, 'status', ...expectations)
